














































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Prop, Vue } from 'vue-property-decorator';
import LayoutContent from '@/components/LayoutContent.vue';
import Accordion from '@/components/Accordion.vue';
import Button from '@/components/Button.vue';
import api, { apiSandbox } from '@/libs/api';
import BcaVA from './Form/BcaVA.vue';
import BriVA from './Form/BriVA.vue';
import MandiriBP from './Form/MandiriBP.vue';
import BniVA from './Form/BniVA.vue';
import BncVA from './Form/BncVA.vue';
import PermataVA from './Form/PermataVA.vue';
import DanamonVA from './Form/DanamonVA.vue';
import MaybankVA from './Form/MaybankVA.vue';
import BAGIVA from './Form/BAGIVA.vue';
import KlikBCA from './Form/KlikBca.vue';
import Others from './Form/Others.vue';
import Others2 from './Form/Others2.vue';

@Component({
  components: {
    Accordion,
    Button,
    BAGIVA,
    BcaVA,
    BriVA,
    MandiriBP,
    BniVA,
    BncVA,
    DanamonVA,
    MaybankVA,
    PermataVA,
    LayoutContent,
    KlikBCA,
    Others,
    Others2,
  },
})
export default class Step3 extends Vue {
  @Prop(Function) onSetStep!: Function;
  trafficAverage = '';
  websiteAddress = '';
  bcaVA: { channels: { service_code: string }[]; service_code: string; service_name: string }[] = [];
  secretKey = '';
  redirectPayment = [
    '1022',
    '1023',
    '1081',
    '1061',
    '1041',
    '1077',
    '1083',
    '1084',
    '1085',
    '1024',
    '1073',
    '1080',
    // '2002',
  ];

  mounted() {
    this.getBankData();
  }

  async getBankData() {
    try {
      this.trafficAverage = '';
      const { data } = await apiSandbox.get('/merchant/channel/detail');
      console.log(data);
      this.bcaVA = data.merchant_channel;
      this.secretKey = data.secret_key;
      // this.bcaVA = data.data.merchant_channel.filter((d: any) => d.channel_name.includes('bca_va'));
    } catch (err) {
      console.error(err);
    }
  }
}
